// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yazio-header[data-v-338ad9d6]{background:linear-gradient(268.29deg,#9686c9,#8272b5 100.74%)}@media (min-width:640px){.yazio-header[data-v-338ad9d6]{background-image:url(/images/yazio/yazioBG.png),linear-gradient(268.29deg,#9686c9,#8272b5 100.74%);background-position:100%;background-size:774px,100%;background-repeat:no-repeat}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
